import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme/contract.css';

/**
 * 전체 미리보기 오버레이 — 작성기와 발송 확인이 같이 쓴다(2026-09-29 에 `outreach-composer` 에서
 * 내려왔다). 초안 하나를 그리는 일이라 entity 층이 맞는다.
 *
 * 🔴 `position: absolute` 다. **여는 쪽이 기준 상자(`position: relative`)여야 한다** — 없으면
 * 화면 전체로 번진다. 작성기는 `OutreachComposer.css` 의 `root` 가, 발송 확인은
 * `SendConfirmPanel.css` 의 `stack` 이 그 기준이다. `fixed` 로 바꾸지 않은 이유는 이 오버레이가
 * 덮개 **안**의 한 겹이라 창 밖까지 덮으면 맥락이 사라지기 때문이다.
 */
export const backdrop = style({
  position: 'absolute',
  inset: 0,
  background: vars.surface.background.opaque,
  zIndex: vars.elevation.localOverlay,
  display: 'flex',
  flexDirection: 'column',
});

export const head = style({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  gap: vars.spacing.gap.sm,
  padding: `${vars.spacing.padding.xs} ${vars.spacing.padding.sm}`,
  borderBottom: `1px solid ${vars.surface.border.subtle}`,
});

export const note = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
});

export const body = style({
  flexGrow: 1,
  minHeight: 0,
  overflowY: 'auto',
  display: 'grid',
  justifyItems: 'center',
  padding: vars.spacing.padding.sm,
});

export const desktop = style({
  width: 600,
  maxWidth: '100%',
  height: '100%',
  minHeight: 480,
  border: `1px solid ${vars.surface.border.subtle}`,
  borderRadius: vars.spacing.borderRadius.md,
});

/** 모바일 렌더 — 좁은 화면에서 이미지와 버튼이 어떻게 접히는지 본다. */
export const mobile = style({
  width: 360,
  maxWidth: '100%',
  height: '100%',
  minHeight: 480,
  border: `1px solid ${vars.surface.border.subtle}`,
  borderRadius: vars.spacing.borderRadius.md,
});
